import { DocumentFormat } from "@/src/data/allTypes";
import { barcode1 } from "@/src/data/data";
import { USER } from "@/src/data/globalVariables";
import Barcode from "react-barcode";
import { HtmlDiv } from "./htmlDiv";
import { getRemedType, uid } from "@/src/utils/utils";
import { UploadedImage } from "@/src/components/uploadSpots";
import { useEffect } from "react";
import moment from "moment";

export function DocumentHeader({ format }: { format: DocumentFormat }) {
  let user = USER.useSubscribe(`headerUser`);
  let service = user?.service;

  useEffect(() => {
    console.log("service", service);
  }, [JSON.stringify(user)]);

  if (!service) return <div></div>;
  let headerType = user?.service?.headerType || "default";
  let className = `documentHeader header-${headerType} headerTheme-${service?.theme}`;
  let titlesHtml = `<div className="bold">${service?.h1 || "-"}</div>
  <div>${service?.h2 || ""}</div>
  <div>${service?.h3 || ""}</div>`;

  let infoChild = (
    <div
      contentEditable={true}
      dangerouslySetInnerHTML={{ __html: titlesHtml }}
    ></div>
  );
  let logoChild = (
    <div>
      {service.logo ? (
        <UploadedImage
          upload={service.logo}
          style={{
            boxShadow: "none",
            background: "transparent",
            height: service.logoHeight || undefined,
            width: service.logoWidth || undefined,
            opacity: service.logoOpacity || undefined,
            padding: service.logoPadding || undefined,
          }}
        />
      ) : (
        <img src="./images/logo3.png" alt="" />
      )}
    </div>
  );

  if (service?.showHeaderBarcodeInsteadOfLogo)
    logoChild = (
      <HtmlDiv
        style={{
          boxShadow: "none",
          background: "transparent",
          height: service.logoHeight || undefined,
          width: service.logoWidth || undefined,
          opacity: service.logoOpacity || undefined,
          padding: service.logoPadding || undefined,
        }}
      >
        {barcode1}
      </HtmlDiv>
    );

  console.log("headerType", headerType);

  if (headerType == "none") return <></>;
  if (headerType == "textRight")
    return (
      <div className={className}>
        <HeaderBackground />
        {logoChild}
        <div className="tright">{infoChild}</div>
      </div>
    );

  if (headerType == "noBarcode") {
    return (
      <div className={className}>
        <div></div>
        <div
          contentEditable={true}
          dangerouslySetInnerHTML={{ __html: titlesHtml }}
        ></div>
        <div></div>
      </div>
    );
  }

  if (headerType == "textLeftAndRightImageCenter")
    return (
      <div className={className}>
        <HeaderBackground />
        <div className="tleft">{infoChild}</div>
        {logoChild}

        <div className="tright">
          <div>{service?.h4 || ""}</div>
          <div>{service?.h5 || ""}</div>
          <div>{service?.h6 || ""}</div>
        </div>
      </div>
    );

  if (headerType == "textLeftImageCenterDateRight")
    return (
      <div className={className}>
        <HeaderBackground />
        <div className="tleft">{infoChild}</div>
        {logoChild}

        <div className="tright" contentEditable={true}>
          Sidi Yahia le:
          <br /> {moment().format("DD/MM/YYYY")}
        </div>
      </div>
    );

  if (headerType == "textCenter")
    return (
      <div className={className}>
        <HeaderBackground />

        {logoChild}
        {infoChild}
      </div>
    );

  if (headerType == "textLeft")
    return (
      <div className={className}>
        <div
          className="tleft"
          contentEditable={true}
          dangerouslySetInnerHTML={{ __html: titlesHtml }}
        ></div>
        <HeaderBackground />

        {logoChild}
      </div>
    );

  if (headerType == "empty") return <div className={className}></div>;

  if (format == "a5")
    return (
      <div className={className} style={{ gridTemplateColumns: "1fr" }}>
        <div></div>
        <div
          contentEditable={true}
          dangerouslySetInnerHTML={{ __html: titlesHtml }}
        ></div>
        <div></div>
      </div>
    );

  return (
    <div className={className}>
      {/* <HeaderBackground /> */}

      <div>
        {getRemedType() == "FORENXPERT" ? (
          <img src="./images/ml-logo.png" alt="" />
        ) : (
          <HtmlDiv>{barcode1}</HtmlDiv>
        )}
      </div>
      <div
        contentEditable={true}
        dangerouslySetInnerHTML={{ __html: titlesHtml }}
      ></div>
      <div>
        {getRemedType() == "FORENXPERT" ? (
          <img src="./images/logo-mustapha.jpg" alt="" />
        ) : (
          <HtmlDiv>{barcode1}</HtmlDiv>
        )}
      </div>
    </div>
  );
}

function HeaderBackground() {
  let user = USER.useSubscribe(`headerBackground`);
  let service = user?.service;
  return <></>;

  if (service?.theme == "curvy")
    return (
      <div className="curvyHeaderBackground">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="visual"
          viewBox="0 0 900 675"
          width="900"
          height="675"
          version="1.1"
        >
          <path
            d="M0 111L37.5 107.5C75 104 150 97 225 97C300 97 375 104 450 108.5C525 113 600 115 675 112C750 109 825 101 862.5 97L900 93L900 0L862.5 0C825 0 750 0 675 0C600 0 525 0 450 0C375 0 300 0 225 0C150 0 75 0 37.5 0L0 0Z"
            fill="RGBA(0, 191, 255, 0.2)"
            stroke-linecap="round"
            stroke-linejoin="miter"
          />
        </svg>
      </div>
    );
  return <div className="curvyHeaderBackground"></div>;
}
